import * as React from "react";

import { appContext } from "../App/appContext"
import { Resources, IModelLaster, IRouteComponent, entitetPath } from "../domene"

import { addUrlParams } from "./url";

import Models = Gf.Web.Models;

function finnValgFilter<TFeltType>(valgKontekst: Models.ValgKontekst<TFeltType>) {
    const foo = (feltType: TFeltType, index: number) => {
        const verdi = valgKontekst.Verdier[index];
        return verdi ? `${feltType}:${verdi}` : "";
    };
    const felter = valgKontekst.Felter;
    const resultat = felter ? felter.map(foo).filter(p => !!p).join("+") : "";
    return resultat ? `?q=${resultat}` : "";
}

export class ModelLaster implements IModelLaster {

    resources: Resources = {};

    constructor(public readonly routeComponent: IRouteComponent) { }

    last<T>(path: string, cacheable: boolean = true): T | undefined {
        const url = addUrlParams(path);
        if(this.resources[url] === undefined) {
            this.updateResource(url, false);
            appContext.addHandler(url, this, cacheable ? undefined : 1000);
        }
        const result = appContext.getIfCached<T>(url);
        if (result && result.error) {
            //appContext.log("ModelLaster.last found error for " + url);
            this.routeComponent.handleError(undefined, result.error);
        } else if (result) {
            //appContext.log("ModelLaster.last already had " + url);
        } else {
            //appContext.log("ModelLaster.last did not have " + url);
        }
        return result ? result.value || undefined : undefined;
    }

    handleDataResponse(response: any, error: any, url: string): void {
        //appContext.log("ModelLaster.handleDataResponse " + url);
        this.updateResource(url, true);
    }

    updateResource(url: string, loaded: boolean): void {
        this.resources[url] = loaded ? null : new Date();
        this.routeComponent.updateState();
    }

    removeHandlers() {
        Object.keys(this.resources).forEach(url => appContext.removeHandler(url, this));
        this.resources = {};
    }

    loadingSince(): Date | null {
        return Object.getOwnPropertyNames(this.resources)
            .reduce((acc: Date | null, url: string) => {
                const res = this.resources[url];
                return res
                    ? (acc ? (acc < res ? acc : res) : res)
                    : acc;
            }, null);
    }

    finnValg<TFeltType>(valgKontekst: Models.ValgKontekst<TFeltType>): Gf.Web.Models.FeltValg[] | undefined {
        const sett = this.last<Gf.Web.Models.FeltValgSett>(`/${entitetPath(valgKontekst.EntitetType)}/Valg/${valgKontekst.FeltType}${finnValgFilter(valgKontekst)}`,
            valgKontekst.Cacheable);
        return sett ? sett.Valg : undefined;
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/ModelLaster.ts